import React from 'react';
import { useTranslation } from '../context/LanguageContext';
import '../styles/LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useTranslation();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'hu' : 'en');
  };

  return (
    <button className="language-switcher" onClick={toggleLanguage} aria-label="Switch language">
      <span className={`lang-option ${language === 'en' ? 'active' : ''}`}>EN</span>
      <span className="lang-divider">|</span>
      <span className={`lang-option ${language === 'hu' ? 'active' : ''}`}>HU</span>
    </button>
  );
};

export default LanguageSwitcher;
